<template>
  <div>
    <transition name="slide">
      <div v-if="showExplanationText" class="text-container">
        <section  class="pt-5 px-5 is-flex explanation-wrapper">
          <div class="mx-6 explanation-text">
            <h1 class="is-size-3">{{ $t(explanationText(".h1")) }}</h1>
            <p class="text-body">{{ $t(explanationText(".p1")) }}</p>
          </div>
          <div class="mx-5 explanation-text">
            <h1 class="is-size-3">{{ $t(explanationText(".h2")) }}</h1>
            <p class="text-body">{{ $t(explanationText(".p2")) }}</p>
          </div>
          <div class="mx-5 explanation-text">
            <h1 class="is-size-3">{{ $t(explanationText(".h3")) }}</h1>
            <p class="text-body">{{ $t(explanationText(".p3")) }}</p>
          </div>
        </section>
      </div>
    </transition>
    <div class="trigger-button cursor-pointer" @click="toggleExplanation(!showExplanationText)">
      <span><i :class="{'fal fa-chevron-up' : showExplanationText, 'fal fa-chevron-down' : !showExplanationText }"></i></span>
    </div>
  </div>
</template>
<script>
import auth from '@/mixins/auth'
export default {
  name: 'Explanation Text',
  components: {
  },
  mixins: [auth],
  props: [],
  data: function () {
    return {
      showExplanationText: false
    }
  },
  mounted: function () {
    this.checkShowExplanation()
  },
  methods: {
    explanationText: function (textElement) {
      return 'homepage.explanation.' + this.$partner + textElement
    },
    checkShowExplanation: function () {
      if (this.isLoggedIn) {
        this.$store.dispatch('getUserSetting', 'showExplanation').then((value) => {
          this.showExplanationText = !!value
        })
      } else {
        this.showExplanationText = true
      }
    },
    toggleExplanation: function (show) {
      this.showExplanationText = show
      if (this.isLoggedIn) {
        const settings = { showExplanation: show }
        this.$store.dispatch('updateUserSettings', { username: this.currentUser.userName, settings })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  .trigger-button {
    color: black;
    font-size: 1.75rem;
    position: absolute;
    z-index: 3;
    right: 25px;
    top: 470px;
    @include mobile {
      font-size: 1.75rem;
      right: 12px;
    }
  }
  section {
    background-color: var(--background-primary);
  }
  h1 {
    font-weight: 700;
    font-size: 2.6rem;
    letter-spacing: 0.1rem;
    margin-bottom: 0;
    text-align: left;
  }
  .text-body {
    line-height: 1.7rem;
    letter-spacing: 0.07rem;
  }
  .slide-enter-active, .slide-leave-active {
      transition: 0.2s max-height ease-out;
      max-height: 250px;
      overflow: hidden;
  }
  .slide-enter, .slide-leave-to {
      max-height: 0;
  }

   @media only screen and (max-width: 1365px) {
    .explanation-wrapper {
      padding: 1rem !important;
    }
    .explanation-text {
      margin: 0 1rem !important;
    }
  }

  @media only screen and (max-width: 1177px) {
    .explanation-text {
      margin: 0 0 1rem 0 !important;
      padding: 1rem !important;
      h1 {
        font-size: 1.5em !important;
      }
    }
  }
  @include touch {
    .explanation-wrapper {
      display: block !important;
      margin: 0 !important;
      padding: 2rem 2rem 0.01rem 2rem !important;
    }
    .explanation-text {
      margin: 0 0 1rem 0 !important;
      padding: 0 !important;
    }
    .slide-enter-active, .slide-leave-active {
      transition: 0.5s max-height ease-out;
      max-height: 500px;
      overflow: hidden;
    }
    .slide-enter, .slide-leave-to {
        max-height: 0;
    }
  }
</style>
